import { createContext, type JSX } from "react";

export const WidgetMenuWrapperContext = createContext<[false | (() => void), false | JSX.Element]>([false, false]);
